const snare = () => {
    return (
        <p>
            <br /><b>Диаметр канала: </b>≥2.0 мм<br /><b>Рабочая длина: </b>1600 мм / 2300 мм<br />
            <br /><br />            
        </p>
    );
}

export default snare;